import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Gift } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-teal-600" data-id="element-96" data-mp="28bal67kuhk7f" />,
    color: 'bg-teal-50 border-teal-200',
    title: 'TOMO 1 — ENTENDÉ Y MEJORÁ SU CONDUCTA',
    subtitle: 'Primero entendé. Después actuá.',
    desc: 'Cuando un niño grita, ignora una indicación, se niega a colaborar o repite una conducta una y otra vez, es fácil concentrarse únicamente en lo que está haciendo. Este tomo te ayuda a observar mejor esos momentos, identificar patrones y comprender qué puede haber detrás de determinadas conductas. Para pasar de “¿Por qué hace esto?” a “Ahora tengo más claridad sobre cómo abordarlo.”'
  }, {
    icon: <BookOpen className="w-8 h-8 text-coral-500" data-id="element-97" data-mp="30zpvwhwy1gcy" />,
    color: 'bg-coral-50 border-coral-100',
    title: 'TOMO 2 — LÍMITES, RABIETAS Y EMOCIONES',
    subtitle: 'Acompañar una emoción no significa eliminar el límite.',
    desc: '¿Qué hacés cuando decís “no” y aparece una rabieta? ¿Qué pasa cuando se frustra? ¿Cedés? ¿Intentás explicarle? ¿Mantenés el límite? Herramientas para abordar rabietas, frustración, enojo, límites, emociones intensas y conflictos cotidianos. Porque podés reconocer lo que siente... sin dejar de sostener el límite.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-600" data-id="element-98" data-mp="29hlurci6m95b" />,
    color: 'bg-amber-50 border-amber-200',
    title: 'TOMO 3 — RUTINAS Y PLAN DE CONDUCTA',
    subtitle: 'Menos improvisación. Más previsibilidad.',
    desc: 'Muchas discusiones aparecen alrededor de los mismos momentos: levantarse, vestirse, guardar juguetes, hacer tareas, apagar pantallas, bañarse y prepararse para dormir. Este tomo te ayuda a construir rutinas y un plan más claro para que el día no dependa constantemente de órdenes, recordatorios y negociaciones.'
  }];
  return <section className="py-12 px-4 bg-cream-100 pt-[4px] pb-[4px]" data-id="element-99" data-mp="329dwb3to7kpw">
      <div className="max-w-5xl mx-auto" data-id="element-100" data-mp="125uw1d64jeav">
        <div className="text-center mb-10" data-id="element-101" data-mp="126mfjpmg5lks">
          <Badge variant="success" className="mb-4" data-id="element-102" data-mp="y5184jsolzhz">
            🧩 PUNTO DIGITAL™ — KIT DE CONDUCTA INFANTIL
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-103" data-mp="1bx7ljy4g9sdq">
            3 Tomos + 5 Bonos
          </h2>
          <p className="text-xl text-ink-muted" data-id="element-104" data-mp="173wf3y3jvdmc">
            Un sistema práctico para dejar de improvisar frente a cada conducta
            difícil
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-teal-600" data-id="element-105" data-mp="1gvsfjft3zftq">
            <span data-id="element-106" data-mp="1uva5vzm1z157">Entendé</span> <span className="text-ink-faint" data-id="element-107" data-mp="1utqqscc4uw50">→</span>
            <span data-id="element-108" data-mp="1pvxhhafj9m0i">Acompañá</span> <span className="text-ink-faint" data-id="element-109" data-mp="1pvp6xp6vussh">→</span>
            <span data-id="element-110" data-mp="1ptuiw20bekk6">Poné límites</span> <span className="text-ink-faint" data-id="element-111" data-mp="gr3dx1igxn6">→</span>
            <span data-id="element-112" data-mp="hiyl6r74tcx">Organizá</span> <span className="text-ink-faint" data-id="element-113" data-mp="j3ky93cx5zp">→</span>
            <span data-id="element-114" data-mp="3roddo8iqjyd0">Aplicá</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-115" data-mp="2759l176wd4ph">
          <h3 className="text-xl font-bold text-navy mb-5 flex items-center gap-3" data-id="element-116" data-mp="274zu9he12tiq">
            <span className="text-3xl" data-id="element-117" data-mp="2c4vxheewigx8">🧩</span> 3 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-118" data-mp="1ycxw5prflpbm">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-119" data-mp="1yb4w4tbbq3cl" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-120" data-mp="22d00k6ojwwul">
                  <div className="p-3 bg-white rounded-xl shrink-0" data-id="element-121" data-mp="1oe8p6s12ppa5">
                    {tomo.icon}
                  </div>
                  <div data-id="element-122" data-mp="1tewftcle443u">
                    <h4 className="font-bold text-navy text-lg mb-1" data-id="element-123" data-mp="1tf66l2e9efal">
                      {tomo.title}
                    </h4>
                    <p className="text-teal-600 text-sm font-medium mb-3" data-id="element-124" data-mp="1jfp2uqikibh9">
                      {tomo.subtitle}
                    </p>
                    <p className="text-ink-muted text-sm leading-relaxed" data-id="element-125" data-mp="39t63e4ht5otm">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-white" data-id="element-126" data-mp="2p0zez2cdu4jy">
          <h4 className="font-bold text-xl text-navy mb-6" data-id="element-127" data-mp="2k3fsjf5j6lgx">
            Qué te llevás con los 3 tomos:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-128" data-mp="2f3ust2ije935">
            {['Comprender mejor determinadas conductas', 'Identificar patrones', 'Tener nuevas herramientas para momentos de rabieta', 'Acompañar emociones sin abandonar los límites', 'Establecer límites con mayor claridad', 'Construir rutinas más predecibles', 'Tener un plan más consistente para situaciones que se repiten todos los días', 'Herramientas que te ayudan a aplicarlo en el día a día'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-129" data-mp="1mf5o6ti9vlmn" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" data-id="element-130" data-mp="1ievi7guhcv7s" />
                <span className="text-ink-muted" data-id="element-131" data-mp="1igzmhzwajw8l">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'TABLA DE RECOMPENSAS',
    desc: 'Una herramienta visual para definir pequeños objetivos, acompañar hábitos y responsabilidades y reconocer avances.',
    value: 'USD 7.00'
  }, {
    title: 'REGISTRO DE CONDUCTA',
    desc: 'Registrá qué pasó antes, durante y después de determinadas situaciones para empezar a identificar patrones que pueden pasar desapercibidos.',
    value: 'USD 7.00'
  }, {
    title: 'TARJETAS DE EMOCIONES',
    desc: 'Un apoyo visual para ayudar al niño a identificar, nombrar y expresar diferentes emociones cuando todavía le cuesta poner en palabras lo que siente.',
    value: 'USD 7.00'
  }, {
    title: 'PACK DE RUTINAS VISUALES',
    desc: 'Recursos visuales para hacer más predecibles momentos como vestirse, ordenar, bañarse, hacer tareas o prepararse para dormir. Menos repetir, más claridad sobre qué toca hacer y qué viene después.',
    value: 'USD 8.00'
  }, {
    title: 'ACUERDO FAMILIAR DE CONDUCTA',
    desc: 'Una herramienta para establecer reglas, responsabilidades y acuerdos familiares de manera más clara y consistente.',
    value: 'USD 8.00'
  }];
  return <section className="py-12 px-4" data-id="element-132" data-mp="2tey7wl4v5qvt">
      <div className="max-w-5xl mx-auto" data-id="element-133" data-mp="25m9bee9culj7">
        <div className="text-center mb-8" data-id="element-134" data-mp="25nay5fzqgwgr">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-3 flex items-center justify-center gap-3" data-id="element-135" data-mp="21lxsb5wn4t9u">
            <Gift className="w-9 h-9 text-teal-500" data-id="element-136" data-mp="2flgyht5w5uji" />5 BONOS PRÁCTICOS
          </h2>
          <p className="text-xl text-teal-600 font-bold uppercase tracking-widest" data-id="element-137" data-mp="2alkv9w50q750">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-138" data-mp="3qysujhvet8v4">
          {bonuses.map((bono, i) => <Card key={i} className="relative overflow-hidden group hover:border-teal-400 transition-colors flex flex-col" data-id="element-139" data-mp="3m116x01ss8wq" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-teal-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-140" data-mp="1ctnwgqq5y7mx">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-navy text-lg mb-3 pr-12 mt-2" data-id="element-141" data-mp="13rn0dx6o1rmu">
                {bono.title}
              </h4>
              <p className="text-ink-muted text-sm mb-6" data-id="element-142" data-mp="1rh932um8yozl">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-cream-300 flex justify-between items-center" data-id="element-143" data-mp="1viul0udn1tgn">
                <span className="line-through text-ink-soft text-sm" data-id="element-144" data-mp="1hrxx3gunq0fx">
                  Valor {bono.value}
                </span>
                <span className="text-emerald-600 font-bold" data-id="element-145" data-mp="1mpr1c4cegkdk">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-teal-50 border border-teal-300 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-146" data-mp="2aea82ffswp3j">
          <p className="text-ink-muted mb-2" data-id="element-147" data-mp="2f8wm6qd9ovrb">Valor de los bonos</p>
          <p className="text-4xl font-black text-navy mb-2 line-through decoration-coral-500/60" data-id="element-148" data-mp="f6ew71ywx7sy">
            USD 37.00
          </p>
          <p className="text-2xl font-bold text-emerald-600" data-id="element-149" data-mp="acaqsn5ap7tz">
            → INCLUIDOS GRATIS CON TU KIT
          </p>
        </div>

        <div className="max-w-3xl mx-auto mt-10 text-center" data-id="element-150" data-mp="gpffyec6v7k">
          <p className="text-lg font-bold text-navy mb-3" data-id="element-151" data-mp="e3a85ex4rsi">
            No estás comprando simplemente 3 PDFs.
          </p>
          <p className="text-ink-muted mb-6" data-id="element-152" data-mp="t43h29szcey0">
            Estás obteniendo un sistema organizado para tener herramientas
            frente a situaciones que aparecen todos los días.
          </p>
          <div className="grid sm:grid-cols-2 gap-3 text-left" data-id="element-153" data-mp="k46vwi5sty7p">
            {['3 Tomos completos', '5 Bonos prácticos', 'Herramientas para comprender conductas', 'Recursos para acompañar emociones', 'Estrategias para establecer límites', 'Apoyo para construir rutinas', 'Materiales visuales para llevarlo a la práctica', 'Todo organizado dentro de un único Kit'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-154" data-mp="1tcjnsyp7ex6q" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" data-id="element-155" data-mp="1taysh6v2fa7t" />
                <span className="text-ink-muted" data-id="element-156" data-mp="1y5l67gomdev2">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}